import { normalizeVariant } from "./shipmentsTransformers";

export const resolveAlertsListParams = ({
  alertsListInfo,
  shipmentCode,
  variant,
}) => {
  const baseParams = {
    message: "Cargando...",
    status: "loading",
    statusCode: 0,
    shipmentCode,
    alertsList: [],
    tempMin: 0,
    tempMax: 0,
    configTempMin: null,
    configTempMax: null,
  };

  if (!alertsListInfo) return baseParams;

  const normalizedVariant = normalizeVariant(variant);
  const variantAlertsData = alertsListInfo?.[normalizedVariant];

  const legacyAlertsData =
    alertsListInfo?.alertsList || alertsListInfo?.tempMin != null
      ? alertsListInfo
      : null;

  const alertsSourceData = variantAlertsData || legacyAlertsData;

  if (!alertsSourceData) {
    return {
      ...baseParams,
      status: "loaded",
      statusCode: alertsListInfo.statusCode ?? 0,
      message: "No se han encontrado datos de telemetría para este envío.",
    };
  }

  const resolvedStatusCode =
    alertsSourceData.statusCode ?? alertsListInfo.statusCode ?? 0;

  if (resolvedStatusCode !== 200) {
    return {
      ...baseParams,
      status: "loaded",
      statusCode: resolvedStatusCode,
      message: "No se han encontrado datos de telemetría para este envío.",
    };
  }

  return {
    ...baseParams,
    status: "loaded",
    statusCode: 200,
    message: "",
    ...alertsSourceData,
  };
};

export const getTemperatureRangeLabel = (params) => {
  const minTemp = params.configTempMin !== null ? `${params.tempMin}°C` : "-";
  const maxTemp = params.configTempMax !== null ? `${params.tempMax}°C` : "-";

  return params.configTempMax === null && params.configTempMin === null
    ? "No aplica rango de temperatura"
    : `Rango de temperatura configurada: ${minTemp} a ${maxTemp}`;
};

export const getAlertIconClass = (alertClass) =>
  alertClass === "warning" ? "warning-icon" : "alert-icon";
